import script from "./BaseToolTip.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseToolTip.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__